<template>
    <div>
      <div>
        <google-button
          :google-id="scope + '-googleSignUp'"
          :classcode="classcode"
          :schoolcode="schoolcode"
          :connect-classroom="connectClassroom"
          :account-type="accountType"
          :sign-up="true"
          @onError="onError"
        />
        <clever-button />
        <classlink-button />
        <v-btn @click="qrLoginPage" outlined style="display:flex; width: 100%; text-transform: none;" class="my-2">
          <v-icon left>{{ icons.mdiQrcode }} </v-icon>
          <span class="pl-3">
            Continue with QR code
          </span>
        </v-btn>
        <div style="margin-top: 30px; margin-bottom: 12px" class="signup_or_line">
          <hr />
          <span>{{ $t('navbar.signup.form.or') }}</span>
        </div>
      </div>
  
      <v-expansion-panels class="signup">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-row align="center" justify="center" no-gutters>
              <v-col cols="auto" class="text-center">
                <v-icon>{{ icons.mdiEmailOutline }}</v-icon>
              </v-col>
              <v-col cols="auto" class="text-center pl-3">
                Sign up with email
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <form
              :data-vv-scope="scope"
              method="post"
              @submit.prevent="submitSignup(scope)"
            >
              <v-alert v-for="e in error" :key="e" :value="true" type="error">
                {{ e }}
              </v-alert>
              <v-text-field
                v-model="name"
                v-validate="{
                  required: true,
                  min: 3,
                  max: 30,
                  regex: /^\w+$/,
                  unique_username: true,
                  blacklist_username: true,
                }"
                :counter="15"
                :error-messages="errors.collect(scope + '.name')"
                data-vv-name="name"
                placeholder="david123"
                required
                outlined
                :label="$t('navbar.signup.form.username')"
              />
              <v-text-field
                v-model="email"
                v-validate="'required|email'"
                :error-messages="errors.collect(scope + '.email')"
                data-vv-name="email"
                required
                name="email"
                placeholder="user@elementari.com"
                outlined
                :label="$t('navbar.signup.form.email')"
              />
              <v-text-field
                ref="pw_confirm"
                v-model="password"
                v-validate="'required|min: 6'"
                :error-messages="errors.collect(scope + '.password')"
                name="password"
                data-vv-name="password"
                :append-icon="
                  show1 ? '$vuetify.icons.mdiEye' : '$vuetify.icons.mdiEyeOff'
                "
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                placeholder="********"
                required
                outlined
                :label="$t('navbar.signup.form.password')"
              />
              <v-text-field
                v-model="password_confirmation"
                v-validate="'required|confirmed:pw_confirm'"
                :error-messages="errors.collect(scope + '.password_confirmation')"
                name="password_confirmation"
                data-vv-name="password_confirmation"
                type="password"
                placeholder="********"
                required
                outlined
                :label="$t('navbar.signup.form.password')"
              />
              <v-btn
                block
                color="primary"
                :disabled="errors.any(scope)"
                depressed
                tile
                type="submit"
              >
                {{ $t('navbar.signup.form.submit') }}
              </v-btn>
            </form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
  
      <v-divider class="mt-3" />
  
      <v-flex x8 class="pt-3 text-center" style="font-size:13px;">
        <span>
          {{ $t('navbar.signup.form.by_signing_up_you_agree_to_our') }}
          <nuxt-link :to="localePath('/policy/terms')">
            {{ $t('navbar.signup.form.terms_of_use') }}
          </nuxt-link>
          {{ $t('navbar.signup.form.and') }}
          <nuxt-link :to="localePath('/policy/terms')">
            {{ $t('navbar.signup.form.privacy_policy') }}
          </nuxt-link>
        </span>
      </v-flex>
    </div>
  </template>
  
  <script>
  import { mdiEmailOutline, mdiQrcode } from '@mdi/js'
  
  export default {
    components: {
      'google-button': () =>
        import('~/components/forms/account/social/GoogleButton'),
      'clever-button': () =>
        import('~/components/forms/account/social/CleverButton'),
      'classlink-button': () =>
        import('~/components/forms/account/social/ClasslinkButton'),
    },
    props: {
      scope: {
        type: [String],
        required: false,
        default: 'signup-form',
      },
      accountType: {
        type: [String],
        required: true,
        default: 'regular',
      },
      classcode: {
        type: [String],
        required: false,
        default: '',
      },
      schoolcode: {
        type: [String],
        required: false,
        default: '',
      }
    },
    inject: ['$validator'],
  
    data: () => ({
      show1: false,
      submitted: false,
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
      icons: {
        mdiEmailOutline,
        mdiQrcode
      },
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'navbar.signup.form.errors.username',
            max: 'navbar.signup.form.errors.max',
            regex: 'navbar.signup.form.errors.regex',
          },
          password: {
            required: () => 'navbar.signup.form.errors.password',
            // custom messages
          },
        },
      },
      error: null,
    }),
    methods: {
      qrLoginPage(){
        this.$store.dispatch('setSignupDialog', false)
        this.$router.push(this.localePath('/login/qr') )
      },
      onError: function (error) {
        this.error = error
      },
      submitSignup(scope) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            let account_type = ''
            if (this.accountType != 'r') {
              account_type = this.accountType
            }
            const formdata = {
              account_type: account_type,
              username: this.name,
              email: this.email,
              password1: this.password,
              password2: this.password_confirmation,
            }
            if (this.schoolcode) {
              formdata.teacher_school = this.schoolcode
            }
            this.registerUser(formdata)
          }
        })
      },
      async setProfile(code) {
        const formdata = {
          lang: code,
        }
        try {
          const res = await this.$api.editUserProfile(this.name, formdata)
        } catch (e) {
          console.log(e)
        }
      },
      async registerUser(formdata) {
        try {
          await this.$api.registerUser(formdata)
          await this.$auth.loginWith('local', {
            data: {
              email: this.email,
              password: this.password,
            },
          })
        } catch (e) {
          const data = e.response.data
          Object.keys(data).map((k) => (this.error = data[k]))
          return
        }
  
  
        // transfer story if was guest mode
        if (this.$route.path.includes('/studio/edit/') && !this.$auth.user) {
          await this.$api.setUserForGuestStory(
            this.$store.state.StudioLauncher.projectDetails.slug,
            { username: this.name }
          )
        }
  
        if (this.accountType == 's') {
          this.connectClassroom(this.name, this.classcode)
        }else{
          await this.$auth.fetchUser()
        }
  
        // setting if user is a teacher and the language preference
        this.setProfile(this.$store.state.i18n.locale)
        this.$store.dispatch('setSignupDialog', false)
  
        if (this.$store.state.StudioLauncher.projectDetails.slug) return
        // redirect if not working on a book
        if (this.$route.path.includes('/signup')) {
          if (this.$store.state.auth.redirect) {
            this.$router.push(this.localePath(this.$store.state.auth.redirect))
          } else {
            this.$router.push(this.localePath('/studio') )
          }
        } else {
          // check if user is mobile
          if (this.$device.isMobile) {
            this.$router.push(this.localePath('/') )
          } else {
            this.$router.push(this.localePath('/studio') )
          }
        }
      },
      async connectClassroom(username, classcode) {
        try {
          const classdata = {
            username: username,
            classcode: classcode,
          }
          await this.$api.setClassbyClasscode(classdata)
          await this.$auth.fetchUser()
          this.$router.push(this.localePath('/') )
        } catch (e) {
          console.log(e)
          return
        }
      },
      getTranslation(path) {
        return this.$i18n.t(String(path))
      },
    },
  }
  </script>
  
  
  <style>
  .signup_or_line {
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    text-align: center;
    position: relative;
    width: 100%;
    flex-direction: row;
  }
  
  .signup_input {
    font-size: 1rem;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 600;
  }
  
  .signup_or_line hr {
    margin: 0px;
    width: 100%;
    border-top: 1px solid rgb(204, 204, 204);
  }
  .signup_or_line span {
    position: absolute;
    padding: 0px 0.5rem;
    background: rgb(255, 255, 255);
    font-weight: bold;
    margin-top: -0.6rem;
    left: 50%;
    transform: translateX(-50%);
  }
  .signup .v-expansion-panel:before {
    box-shadow: none !important;
  }
  .signup .v-expansion-panel-content__wrap{
    padding: 0 auto;
  }
  </style>